import { ApiUrl, header } from "../utils/modules.js";
import { fetchRecordingBlob } from "../utils/recordingAudio.js";

export const getRecordingBlob = (pathRecord, { signal } = {}) =>
  fetchRecordingBlob(pathRecord, {
    apiUrl: ApiUrl,
    pageUrl: window.location.href,
    authorization: header().headers.Authorization,
    signal,
  });
